import LogInterceptor from './LogInterceptor';
import ConsoleLog from './utils/ConsoleLog';
import PlatformUtil from "../utils/PlatformUtil";

const TAG = 'AppLogRequester';
/**
 * This class provides the ability to pass log data from the WebView to the App in the Coupang App
 */
export default class AppLogRequester {
  private logInterceptor: LogInterceptor<object>;

  constructor(logInterceptor?: LogInterceptor<object>) {
    this.logInterceptor = logInterceptor || new LogInterceptor<object>();
  }

  /**
   * Send the log data to Coupang App.
   *
   * @param jsonData JSON object for log data
   */
  send(jsonData: object): void {
    const _jsonData = this.logInterceptor.runRequestInterceptor(jsonData);
    const jsonString = JSON.stringify(_jsonData);

    if (PlatformUtil.hasAndroidFunction()) {
      ConsoleLog.d(TAG, `#send - using window.CoupangAppTrackin.logEvent function`);
      window.CoupangAppTracking.logEvent(jsonString);
    } else if (PlatformUtil.hasIOSFunction()) {
      ConsoleLog.d(TAG, `#send - using window.webkit.messageHandlers.callBackHandler.postMessage function`);
      window.webkit.messageHandlers.callBackHandler.postMessage(jsonString);
    } else {
      ConsoleLog.w(TAG, '#send - Not found App Function.');
      return;
    }
    ConsoleLog.i(TAG, `#sendToApp - jsonString \n ${jsonString}`);
  }
}
